export default __webpack_public_path__ + "static/media/kitchen3-afterB-2048w.fac81954.webp";